import React, { useEffect, useState } from "react";
import logo from "../assets/images/logo.webp";
import { RiMenu4Line } from "react-icons/ri";
import { supabase } from "../../supabase";
import { Link, useNavigate } from "react-router-dom";
import { MdLogout } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";
import { CgLivePhoto } from "react-icons/cg";

function AdminNavbar() {
  const navigate = useNavigate();
  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();

    if (error) {
      toast.error(error.message);
    } else {
      toast.success("Logged out successfully");
      navigate("/admin-login");
    }
  };

  const closeNavbar = () => {
    const navbar = document.getElementById("navbarSupportedContent");

    if (navbar && navbar.classList.contains("show")) {
      const bsCollapse = new window.bootstrap.Collapse(navbar, {
        toggle: false,
      });
      bsCollapse.hide();
    }
  };
  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top">
        <div className="container">
          <Link className="admin-brand" to="/admin-live-bookings">
            <img src={logo}  />
          </Link>

          <RiMenu4Line
            className="navbar-menu-bar me-2"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
          />

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className="navbar-nav me-auto mb-2">
              {/* <span className="ms-5"></span> */}
              <li
                className="nav-item ms-5 mt-2"
                style={{ color: "grey", fontSize: "0.9rem" }}
              >
                {/* <FaLocationDot style={{color:'#ff4e3b'}} className="icon"/> {loading ? "Fetching..." : location} */}
              </li>
            </div>

            <div className="d-flex">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link
                    onClick={closeNavbar}
                    className="nav-link text-danger animated-text"
                    to="/admin-live-bookings"
                  >
                    <CgLivePhoto className="icon" /> Live Bookings
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={closeNavbar}
                    className="nav-link"
                    to="/admin-bookings-history"
                  >
                    Booking History
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={closeNavbar}
                    className="nav-link"
                    to="/add-offline-booking"
                  >
                    Add Booking
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    onClick={closeNavbar}
                      className="nav-link"
                    to="/admin-cars"
                  >
                    Cars
                  </Link>
                </li>

                {/* <li className="nav-item">
                  <Link className="nav-link" to="/admin-drivers">
                    Drivers
                  </Link>
                </li> */}
                {/* <li className="nav-item">
                  <a className="nav-link" href="/my-profile">
                    My Profile
                  </a>
                </li> */}
                <li className="nav-item">
                  <a
                    className="nav-link text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={handleLogout}
                  >
                    <MdLogout className="icon me-1" /> LogOut
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default AdminNavbar;
